import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../api/index';
import images from '../../images';

const AdvertiserModal = ({ isOpen, onClose, advertiserData }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [name, setName] = useState(advertiserData?.name || '');
  const [isEditingName, setIsEditingName] = useState(false);
  const [editNameValue, setEditNameValue] = useState(name);
  const [email, setEmail] = useState(advertiserData?.email || '');
  const [password, setPassword] = useState('');
  const [upk, setUpk] = useState(advertiserData?.upk || '');
  const [balance, setBalance] = useState(advertiserData?.money || 0);
  const [tg_utl, setTgUrl] = useState(advertiserData?.tg_utl || '');
  const [login, setLogin] = useState(advertiserData?.login || '');

  // Состояние для отображения ошибок
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isEditMode = !!advertiserData;

  // Сбрасываем состояние при изменении advertiserData
  useEffect(() => {
    if (advertiserData) {
      setName(advertiserData.name || '');
      setEditNameValue(advertiserData.name || '');
      setEmail(advertiserData.email || '');
      setPassword('');
      setUpk(advertiserData.upk || '');
      setBalance(advertiserData.money || 0);
      setTgUrl(advertiserData.tg_utl || '');
      setLogin(advertiserData.login || '');
    } else {
      setName('');
      setEditNameValue('');
      setEmail('');
      setPassword('');
      setUpk('');
      setBalance(0);
      setTgUrl('');
      setLogin('');
    }
  }, [advertiserData]);

  const handleNameSave = () => {
    setName(editNameValue);
    setIsEditingName(false);
  };

  const handleSubmit = async () => {
    setError('');
    setIsSubmitting(true);

    // Проверка обязательных полей
    if (!name || !name.trim()) {
      setError('Пожалуйста, заполните обязательное поле: Название рекламодателя');
      setIsSubmitting(false);
      return;
    }
    
    if (!email || !email.trim()) {
      setError('Пожалуйста, заполните обязательное поле: Почта');
      setIsSubmitting(false);
      return;
    }
    
    if (!upk || !upk.trim()) {
      setError('Пожалуйста, заполните обязательное поле: ЮПК');
      setIsSubmitting(false);
      return;
    }
    
    // Для режима создания пароль обязателен
    if (!isEditMode && (!password || !password.trim())) {
      setError('Пожалуйста, заполните обязательное поле: Пароль');
      setIsSubmitting(false);
      return;
    }

    const advertiserDataToSubmit = {
      name,
      login,
      email,
      password,
      upk,
      balance: parseInt(balance, 10) || 0,
      tg_utl
    };
    
    try {
      if (isEditMode && advertiserData?.id) {
        // Редактирование: PATCH /users/{id}/profile
        await apiRequest(`users/${advertiserData.id}/profile`, 'PATCH', advertiserDataToSubmit);
      } else {
        // Создание: POST /users/register
        await apiRequest('users/register', 'POST', advertiserDataToSubmit);
      }
      onClose();
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      setError(error.message || 'Ошибка при сохранении');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={isMobile ? "modal-overlay-mobile" : "modal-overlay"} onClick={onClose}>
      <div 
        className="modal fullscreen bottom-right open"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          {isMobile && (
              <button className="modal-close-btn" onClick={onClose} aria-label="Закрыть">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          <h3>
            {isEditingName ? (
              <input
                type="text"
                value={editNameValue}
                onChange={(e) => {setEditNameValue(e.target.value)}}
                onBlur={handleNameSave}
                required
                autoFocus
              />
            ) : (
              <span 
                className="advertiser-name-display"
                onClick={() => setIsEditingName(true)}
              >
                {name || 'Название не указано *'}
              </span>
            )}
            <button
              className="advertiser-name-edit-btn"
              onClick={(e) => {
                e.stopPropagation();
                setIsEditingName(true);
              }}
            >
              <img src={images.penLinear} alt="edit" className="advertiser-edit-icon" />
            </button>
          </h3>
        </div>
        <div className="modal-body">
          {error && (
            <div className="modal-error">
              {error}
            </div>
          )}
          <div className="advertiser-form-row">
            <label className="advertiser-form-label">
              Почта *
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value); setLogin(e.target.value)
                }}
                className="advertiser-form-input"
                required
              />
            </label>
          </div>
          <div className="advertiser-form-row">
            <label className="advertiser-form-label">
              Пароль *
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="advertiser-form-input"
                required
              />
            </label>
          </div>
          <div className="advertiser-form-row">
            <label className="advertiser-form-label">
              ЮПК *
              <input
                type="text"
                value={upk}
                onChange={(e) => setUpk(e.target.value)}
                className="advertiser-form-input"
                required
              />
            </label>
            <label className="advertiser-form-label">
              Баланс
              <input
                type="number"
                value={balance}
                onChange={(e) => setBalance(e.target.value)}
                className="advertiser-form-input"
              />
            </label>
          </div>
          <div className="advertiser-form-row">
            <label className="advertiser-form-label">
              Ссылка на чат TG
              <input
                type="text"
                value={tg_utl}
                onChange={(e) => setTgUrl(e.target.value)}
                className="advertiser-form-input"
              />
            </label>
          </div>
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isEditMode ? 'Обновить рекламодателя' : 'Добавить рекламодателя'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvertiserModal;
